import { Backdrop, CircularProgress, Container } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Success from '../../../../components/Form/Success';
import PageTitle from '../../../../components/ui/PageTitleUI';
import { useAuth } from '../../../../hooks/auth';
import { useStyles } from '../../Style';
import MvmApi from '../../../../services/MvmApi';
import MvmOutgoingRequestSummary from '../../components/MvmOutgoingRequestSummary';
import MvmOutgoingInvoiceRequestRackTypeList from '../../components/MvmOutgoingRequestRackTypeList';
import MvmOutgoingInvoiceRequestLogList from '../../components/MvmOutgoingInvoiceRequestLogList';
import { ArrowBack } from '@material-ui/icons';
import ButtonUI from '../../../../components/ui/ButtonUI';

interface IFormInput {
    rackTypes: any;
    logs: any;
}



const Submit: React.FC = () => {
    const classes = useStyles()
    const { user } = useAuth()
    const history = useHistory()
    const { t: tGeneral } = useTranslation("General")
    const { t: tMvm } = useTranslation("Mvm")
    const { t: tAuthorizeEntryPlant } = useTranslation("AuthorizeEntryPlant")
    const { enqueueSnackbar } = useSnackbar()
    const [circularLoading, setCircularLoading] = useState(false)
    
    const [success, setSuccess] = useState(false)
    const [originalRequest, setOriginalRequest] = useState<any>(null)

    const isView = window.location.pathname.toLowerCase().includes('/view')
    const originalRequestId = window.location.pathname.replaceAll('/', '').toLowerCase().replace('submitoutgoinginvoicerequest', '').replace('view', '')

    const { control, handleSubmit, setValue } = useForm<IFormInput>(
    {
        defaultValues: {     
            rackTypes: [],
            logs: []
         }
    })

    const opcoes = [
        { url: '/OutgoingInvoiceRequest', descricao: tGeneral('search'), state: {}},
        { url: '/ShedManage/4', descricao: tAuthorizeEntryPlant('manageShed'), state: {}},
    ]

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        //     history.replace('NoPermission')

        if (!originalRequestId) {
            enqueueSnackbar(tMvm("requestNotFound"), { variant: 'warning' })
            history.replace('/OutgoingInvoiceRequest')
            return
        }

        setCircularLoading(true)

        MvmApi.getMvmOutgoingInvoiceRequest(originalRequestId)
            .then((response : any) => {
                if (response ) {

                    if (!isView && response.status !== 'REN')
                        history.replace('/NoPermission')

                    setOriginalRequest(response)
                    setValue("rackTypes", response.rackTypes)
                    setValue("logs", response.logs)
                }
                else {
                    enqueueSnackbar(tMvm("requestNotFound"), { variant: 'warning' })
                    history.replace('/OutgoingInvoiceRequest')
                }
            })
            .finally(() => setCircularLoading(false))

    }, [history, user])

    const onSubmit = (data: any) => {

        var request = { 
            mvmOutgoingInvoiceRequestBaseId: originalRequestId,
            rackTypes: data.rackTypes
        }

        setCircularLoading(true)

        MvmApi.createCorrectionMvmOutgoingInvoiceRequest(request)
        .finally(() => {
                setCircularLoading(false)
                setSuccess(true)
            })
    }
   
    if (success)
    return (
        <Container maxWidth={false} component="main">
            <div className={classes.rootContent}>
                <div className={classes.paper}>
                    <Success opcoes={opcoes}/>
                </div>
            </div>
        </Container>
    )
    else   
    return (
        <Container maxWidth={false} component="main">

            <Backdrop style={{ zIndex: 9999 }} open={circularLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>
           
            <PageTitle title={(isView ? tMvm("viewOutgoingInvoiceRequest") : tMvm("createCorrectionOutgoingInvoiceRequest")) + " - " + originalRequestId } />
            <form onSubmit={handleSubmit(onSubmit)} >
                <MvmOutgoingRequestSummary
                    control={control}
                    mvmOutgoingInvoiceRequest={originalRequest}
                    isView={isView}/>
                <MvmOutgoingInvoiceRequestRackTypeList
                    isView={isView}
                    control={control}
                    name={"rackTypes"}/>
                <MvmOutgoingInvoiceRequestLogList
                    control={control}
                    name={"logs"}/>
                <ButtonUI
                    variant="outlined"
                    color="secondary"
                    onClick={() => history.replace('/OutgoingInvoiceRequest')}
                    startIcon={<ArrowBack />}>
                    {tGeneral("back")}
                </ButtonUI>
                { !isView &&
                    <ButtonUI 
                        type="submit" 
                        color="primary">{tMvm("submitCorrectionOutgoingInvoiceRequest")}</ButtonUI>
                }
            </form>
        </Container>
    )
}
export default Submit;